import {CustomCode} from "../../../model/common.model";

export class CostDistributionType extends CustomCode{
public static _registered = new Map<string, CostDistributionType>();
static SEGMENT1 = new CostDistributionType('SEGMENT1');
  static SEGMENT2 = new CostDistributionType('SEGMENT2');
  static SEGMENT3 = new CostDistributionType('SEGMENT3');
  static SEGMENT4 = new CostDistributionType('SEGMENT4');
  static SEGMENT5 = new CostDistributionType('SEGMENT5');
  static SEGMENT6 = new CostDistributionType('SEGMENT6');

  static DIVISION = new CostDistributionType('DIVISION');
  static SERVICE = new CostDistributionType('SERVICE');
  static DEPARTMENT = new CostDistributionType('DEPARTMENT');
  static SUBDEPARTMENT = new CostDistributionType('SUBDEPARTMENT');

  static SI_ACCUMULATION_TYPE = new CostDistributionType('SI_ACCUMULATION_TYPE');
  static SI_TIME_TYPE = new CostDistributionType('SI_TIME_TYPE');
  static SI_COST_TYPE = new CostDistributionType('SI_COST_TYPE');
  static SI_LABOR_CLASS = new CostDistributionType('SI_LABOR_CLASS');
  static SI_LABOR_SHIFT = new CostDistributionType('SI_LABOR_SHIFT');
  static SI_LABOR_UNION = new CostDistributionType('SI_LABOR_UNION');
  static SI_DEPARTMENT = new CostDistributionType('SI_DEPARTMENT');
  static SI_LOCATION = new CostDistributionType('SI_LOCATION');

static ALL = Array.from(CostDistributionType._registered.values());
  static SEGMENTS = [CostDistributionType.SEGMENT1,CostDistributionType.SEGMENT2,CostDistributionType.SEGMENT3,CostDistributionType.SEGMENT4,CostDistributionType.SEGMENT5,CostDistributionType.SEGMENT6];
  static SAGE_INTACCT = [CostDistributionType.SI_ACCUMULATION_TYPE,CostDistributionType.SI_TIME_TYPE,CostDistributionType.SI_COST_TYPE,CostDistributionType.SI_LABOR_CLASS,
  CostDistributionType.SI_LABOR_SHIFT,CostDistributionType.SI_LABOR_UNION,CostDistributionType.SI_DEPARTMENT,CostDistributionType.SI_LOCATION];

  constructor (code: string) {
    super(code);
    CostDistributionType._registered.set(code, this);
  }


static retrieveFromCode(code: string): CostDistributionType {
    const res = CostDistributionType._registered.get(code);
    if (!res) {
      console.log('CostDistributionType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  toTranslateKey():string{
    return 'COST_DISTRIBUTION_TYPE_' + this.code;
  }

}
